import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '../../ui/Button/Button';
import { LinkButton } from '../../ui/LinkButton/LinkButton';
import { TranslationKey } from '../../i18n/translationKeys';
import { OnboardingDots } from './OnboardingDots';
import { type OnboardingFooterProps } from './types';

/**
 * Back/Next navigation bar shared by every carousel screen.
 *
 * The progress dots are shown on every screen, including screen 1 — only the Back link is withheld
 * there (nothing to go back to).
 */
export const OnboardingFooter: React.FC<OnboardingFooterProps> = ({
    step, total, onBack, onNext, nextLabel, nextDisabled, nextLoading,
}) => {
    const { t } = useTranslation();

    return (
        <div className="flex items-center justify-between border-t border-line pt-l">
            <OnboardingDots total={total} current={step} />
            <div className="flex items-center gap-l">
                {step > 1 && (
                    <LinkButton data-testid="onboarding-back-btn" onClick={onBack}>
                        {t(TranslationKey.Onboarding.Nav.Back)}
                    </LinkButton>
                )}
                <Button data-testid="onboarding-next-btn" onClick={onNext} disabled={nextDisabled} loading={nextLoading}>
                    {nextLabel}
                </Button>
            </div>
        </div>
    );
};
